import styled from 'styled-components'

export const Wrapper = styled.div`
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: default;
  max-width: 500px;
  margin: auto;

  img {
    max-width: 100%;
    max-height: 100%;
  }
`
